import { generateImagePath } from '../../../../helpers/helpers';
import AddMoreButton from '../inputs/AddMoreButton';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';

export default function InfoSection({
  handleInputChange,
  dispatch,
  investmentData,
  handleAddItem,
  removeItemFromArray,
}) {
  // English Info Section Fields
  const infoSectionFieldsEn = investmentData.en.infoSection.items.map(
    (item, index) => ({
      label: `Info ${index + 1}`,
      value: item,
      section: 'infoSection',
      field: 'items',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    }),
  );

  // Arabic Info Section Fields
  const infoSectionFieldsAr = investmentData.ar.infoSection.items.map(
    (item, index) => ({
      label: `معلومة ${index + 1}`,
      value: item,
      section: 'infoSection',
      field: 'items',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    }),
  );

  return (
    <section className="mb-5">
      <h3 className="mb-3">Project Info</h3>
      <img
        src={generateImagePath('info-section.webp')}
        alt=""
        className="mb-3 w-100"
      />

      <div className="row">
        {/* English Fields */}
        <div className="col-md-6">
          {infoSectionFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  index: field.index,
                })
              }
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>

        {/* Arabic Fields */}
        <div className="col-md-6" dir="rtl">
          {infoSectionFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
      </div>

      {/* Combined Add and Remove Button (centered) */}
      <AddMoreButton
        handleAddItem={() => handleAddItem('infoSection', 'items')}
      />
    </section>
  );
}
